import styled, { css } from "styled-components"
import theme from "../../../UI/theme"

export const TableData = styled.td`
    padding: 2px 10px;

    &>label {
        cursor: inherit;
    }
`

export const TDHeader = styled.th`
    position: sticky;
    top: 85px;

    @media only screen and (max-width: ${theme.screenSizes.medium - 1}px) {
        top: 0;
    } 

    padding: 2px 10px;
    background-color: ${theme.colors.darkSpace90};
    white-space: nowrap;
    cursor: pointer;

    &>label {
        cursor: inherit;
    }

    ${props => props.sorted === true && css`
        color: ${theme.colors.greenReadable};
    `}

    &:after {

        ${props => props.sorted === true && css`
            content: "";
            width: 0;
            height: 0;
            position: absolute;
            border: 5px solid transparent;
            
            ${props => props.ascending === true && css`
                border-bottom: 5px solid ${theme.colors.greenEnergy};
                top: -5px;
            `}
            ${props => props.ascending === false && css`
                border-top: 5px solid ${theme.colors.greenEnergy};
            `}
        `}
    }
`

export const TableRow = styled.tr`
    :hover {
        background-color: ${theme.colors.darkSpace60} !important;
    }
`

export const ClickableTableRow = styled(TableRow)`
    cursor: pointer;
`

export const HeaderRow = styled.tr`
    background-color: ${theme.colors.darkSpace90};
    color: ${theme.colors.textGray};
`

export const SortIconContainer = styled.div`
    cursor: pointer;
    background-color: ${theme.colors.darkSpace70};
    color: white;
    width: 1.5rem;
    height: 1.5rem;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    
    ${props => props.sorted && css`
        background-color: ${theme.colors.darkSpace80};
        color: ${theme.colors.greenEnergy};
    `}

    :hover {
        background-color: ${theme.colors.darkSpace80};
    }
`

export const TableHeader = styled.th`
    text-align: -webkit-center;
`

export const THead = styled.thead`
    position: sticky;
    top: 0;
`

export const TableContainer = styled.div`
    overflow-x: auto;
    margin-bottom: 100px;
    max-height: 80vh;
`

export const Table = styled.table`
    min-width: 100%;
    table-layout: auto;
    border-spacing: 1px;
    text-size-adjust: none;

    tbody {
        ${TableRow}:nth-of-type(even) {
            background-color: ${theme.colors.darkSpace80};
        }
    
        ${TableRow}:nth-of-type(odd) {
            background-color: ${theme.colors.darkSpace70};
        }
    }

    td {
        white-space: nowrap;
    }
`

export const ErrorText = styled.label`
    border: 2px solid ${theme.colors.darkSpace90};
    border-radius: 4px;
    padding: 5px 5px;
    margin: 0 10px;
    

    ${props => props.color && css`
        color: ${props.color};
    `}
`

export const DetailsRow = styled.tr`
    background-color: ${theme.colors.darkSpace90};
`

export const DetailsContainer = styled.div`
    display: flex;
    flex-direction: column;
    color: ${theme.colors.textGray};
    padding: 10px 0;
`

export const Indicator = styled.div`
    height: 12px;
    width: 12px;
    border-radius: 2px;
    display: inline-block;
    
    ${props => props.color && css`
        background-color: ${props.color};
    `}
`

export const ObjectDetailsContainer = styled.div`
    position: relative;
    display: inline-block;
`

export const SupportTableViewContainer = styled.div`
    display: grid;
    grid-template-columns: 1fr;
    grid-gap: 10px;
    padding: 0 10px;
    box-sizing: border-box;
`

export const SearchContainer = styled.div`
    display: grid;
    grid-template-columns: 3fr 2fr;
    grid-gap: 10px;
    overflow: hidden;
`